export default [
  {
    name: "产品申报",
    path: "/competition/declareRecord",
    sign: "1",
  }
]